import { jwtDecode } from "jwt-decode";

const AI_SITE_URL = "https://aibeyondschools.co.tz";

export function goToAiClasses() {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    window.location.href = "/signin?redirect=ai";
    return;
  }

  try {
    const decoded = jwtDecode(token);
    const notExpired = decoded.exp * 1000 > Date.now();

    if (!notExpired) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userInfo");
      window.location.href = "/signin?redirect=ai";
      return;
    }
  } catch (e) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userInfo");
    window.location.href = "/signin?redirect=ai";
    return;
  }

  window.location.href = `${AI_SITE_URL}/auth#token=${encodeURIComponent(token)}`;
}
